
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.10.0
 * Query Engine version: efdf9b1183dddfd4258cd181a72125755215ab7b
 */
Prisma.prismaVersion = {
  client: "3.10.0",
  engine: "efdf9b1183dddfd4258cd181a72125755215ab7b"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.OrganizationScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  credits: 'credits'
});

exports.Prisma.OrganizationUserScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  organizationId: 'organizationId',
  credits: 'credits',
  role: 'role',
  locked: 'locked'
});

exports.Prisma.VideoScalarFieldEnum = makeEnum({
  id: 'id',
  caseId: 'caseId',
  source: 'source',
  name: 'name',
  lastWatched: 'lastWatched',
  length: 'length',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deleted: 'deleted'
});

exports.Prisma.IntentsScalarFieldEnum = makeEnum({
  id: 'id',
  data: 'data',
  billingId: 'billingId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  caseId: 'caseId'
});

exports.Prisma.CaseScalarFieldEnum = makeEnum({
  id: 'id',
  createdUserId: 'createdUserId',
  reviewedUserId: 'reviewedUserId',
  approvedUserId: 'approvedUserId',
  name: 'name',
  state: 'state',
  caseNumber: 'caseNumber',
  officer: 'officer',
  badgeNumber: 'badgeNumber',
  personInQuestion: 'personInQuestion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  paid: 'paid',
  cost: 'cost',
  status: 'status',
  form: 'form'
});

exports.Prisma.BillingScalarFieldEnum = makeEnum({
  id: 'id',
  address: 'address',
  stripeId: 'stripeId',
  userId: 'userId'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  auth: 'auth',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phoneNumber: 'phoneNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  role: 'role',
  pending: 'pending'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: 'JsonNull'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull',
  AnyNull: 'AnyNull'
});
exports.OrganizationRole = makeEnum({
  ADMIN: 'ADMIN',
  STAFF: 'STAFF'
});

exports.VideoStatus = makeEnum({
  UNWATCHED: 'UNWATCHED',
  IN_PROGRESS: 'IN_PROGRESS',
  WATCHED: 'WATCHED'
});

exports.IntentStatus = makeEnum({
  COMPLETE: 'COMPLETE',
  PENDING: 'PENDING'
});

exports.PurchaseType = makeEnum({
  TOTAL: 'TOTAL',
  CREDITS: 'CREDITS'
});

exports.CaseStatus = makeEnum({
  AWAITING_VIDEOS: 'AWAITING_VIDEOS',
  AWAITING_SUBMISSION: 'AWAITING_SUBMISSION',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  SUBMITTED_PENDING_ASSIGNMENT: 'SUBMITTED_PENDING_ASSIGNMENT',
  SUBMITTED_PENDING_REVIEW: 'SUBMITTED_PENDING_REVIEW',
  SUBMITTED_PENDING_APPROVAL: 'SUBMITTED_PENDING_APPROVAL',
  SUBMITTED_PENDING_FEEDBACK: 'SUBMITTED_PENDING_FEEDBACK',
  COMPLETE: 'COMPLETE',
  HIDDEN: 'HIDDEN'
});

exports.Role = makeEnum({
  USER: 'USER',
  ADMIN: 'ADMIN',
  REVIEWER: 'REVIEWER'
});

exports.Prisma.ModelName = makeEnum({
  Organization: 'Organization',
  OrganizationUser: 'OrganizationUser',
  Video: 'Video',
  Intents: 'Intents',
  Case: 'Case',
  Billing: 'Billing',
  User: 'User'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
